import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Library FTE Estimate: The projected full-time equivalent (FTE) effort of personnel working in the library for cost allocation.',
    name: 'Library FTE Estimates',
    partialId: PartialId.Standard.create('lib_ftes'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
